import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { instance, inProgress, accounts } = useMsal();
    const location = useLocation();
    const isAuthenticated = accounts.length > 0;

    useEffect(() => {
        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            instance.loginRedirect({
                scopes: ['User.Read'],
                redirectStartPage: location.pathname,
            });
        }
    }, [isAuthenticated, inProgress, instance, location]);

    // Prevent rendering route while login is happening or just before
    if (inProgress !== InteractionStatus.None || !isAuthenticated) {
        return null;
    }

    return children;
};

export default ProtectedRoute;
